export default __webpack_public_path__ + "static/media/7B.61517841.png";